module.exports = __webpack_public_path__ + "static/ava-4a3bea84e4aff8346153a07b082ed54c.svg";